import PendenciaItem from './PendenciaItem';

export default PendenciaItem;
